// -----------------------------------------------------------------------------
// SENTINEL mock / demonstration data layer.
// All UI reads from these exports. Swap this module for Supabase queries later
// without touching the components. Values here are DEMONSTRATION DATA only.
// -----------------------------------------------------------------------------

export const RISK = {
  SAFE: {
    key: "SAFE",
    label: "Safe",
    hex: "#10B981",
    tint: "rgba(16,185,129,0.12)",
    border: "rgba(16,185,129,0.4)",
    text: "text-emerald-400",
  },
  LOW: {
    key: "LOW",
    label: "Low",
    hex: "#10B981",
    tint: "rgba(16,185,129,0.12)",
    border: "rgba(16,185,129,0.4)",
    text: "text-emerald-400",
  },
  MEDIUM: {
    key: "MEDIUM",
    label: "Medium",
    hex: "#F59E0B",
    tint: "rgba(245,158,11,0.12)",
    border: "rgba(245,158,11,0.4)",
    text: "text-amber-400",
  },
  HIGH: {
    key: "HIGH",
    label: "High",
    hex: "#EF4444",
    tint: "rgba(239,68,68,0.14)",
    border: "rgba(239,68,68,0.45)",
    text: "text-red-400",
  },
};

export function scoreToLevel(score) {
  if (score >= 67) return "HIGH";
  if (score >= 34) return "MEDIUM";
  if (score >= 12) return "LOW";
  return "SAFE";
}

// Current demonstration safety snapshot shown on the dashboard.
export const safetySnapshot = {
  state: "HIGH",
  riskScore: 91,
  guardianMode: true,
  modeLabel: "Demo monitoring state",
  guardianStatus: "Monitoring active",
};

// Location is not part of the incidents feed; shown as a device capability.
export const locationStatus = {
  available: false,
  label: "Location Services",
  note: "No location attached to incident records",
  statusLabel: "Standby",
  accuracy: "—",
  source: "GPS + Network",
  updated: "—",
};

export const systemStatus = [
  { key: "accelerometer", label: "Accelerometer", state: "Active", ok: true },
  { key: "gyroscope", label: "Gyroscope", state: "Active", ok: true },
  { key: "microphone", label: "Audio Analysis", state: "Active", ok: true },
  { key: "gps", label: "Location (GPS)", state: "Active", ok: true },
  { key: "connectivity", label: "Network Uplink", state: "Stable", ok: true },
  { key: "battery", label: "Battery", state: "Demo", ok: true },
];

// Neutral demonstration emergency contacts.
export const emergencyContacts = [
  {
    id: "c-01",
    name: "Mom",
    relationship: "Emergency Contact",
    phone: "+91 90000 00000",
    primary: true,
  },
  {
    id: "c-02",
    name: "Dad",
    relationship: "Emergency Contact",
    phone: "+91 90000 00001",
    primary: false,
  },
  {
    id: "c-03",
    name: "Friend",
    relationship: "Emergency Contact",
    phone: "+91 90000 00002",
    primary: false,
  },
];

const DEMO_LOCATION = {
  label: "Location unavailable",
  coordinates: "—",
  accuracy: "—",
};

// Realistic Sentinel demonstration incidents.
export const incidents = [
  {
    id: "INC-2041",
    level: "HIGH",
    score: 91,
    eventType: "Sudden Impact + Inactivity",
    timestamp: "2026-06-18T21:14:00Z",
    status: "Awaiting verification",
    locationAvailable: true,
    location: DEMO_LOCATION,
    sensors: [
      { sensor: "Accelerometer", reading: "Sharp impact spike, then static" },
      { sensor: "Motion", reading: "No movement detected after event" },
      { sensor: "Audio", reading: "Abrupt change in ambient sound" },
    ],
    aiContext: "Sudden acceleration followed by reduced movement was detected.",
    recommendedAction: "Verify the user's safety.",
    verification: "Awaiting user response",
    escalation: "Active",
  },
  {
    id: "INC-2039",
    level: "MEDIUM",
    score: 64,
    eventType: "Abnormal Movement Pattern",
    timestamp: "2026-06-18T19:02:00Z",
    status: "Monitoring",
    locationAvailable: true,
    location: DEMO_LOCATION,
    sensors: [
      { sensor: "Motion", reading: "Irregular movement pattern" },
      { sensor: "GPS", reading: "Deviation from usual route" },
      { sensor: "Audio", reading: "Nominal ambient levels" },
    ],
    aiContext: "Movement pattern deviated from the user's normal baseline.",
    recommendedAction: "Continue monitoring and check in if it persists.",
    verification: "Monitoring",
    escalation: "Not triggered",
  },
  {
    id: "INC-2037",
    level: "LOW",
    score: 28,
    eventType: "Unusual Motion Detected",
    timestamp: "2026-06-18T16:41:00Z",
    status: "Resolved",
    locationAvailable: true,
    location: DEMO_LOCATION,
    sensors: [
      { sensor: "Accelerometer", reading: "Brief unusual motion burst" },
      { sensor: "Motion", reading: "Normal activity resumed" },
    ],
    aiContext: "A short burst of unusual motion was detected, then normal activity resumed.",
    recommendedAction: "No action required.",
    verification: "Confirmed safe",
    escalation: "Not triggered",
  },
];

// Snapshot used for the dedicated Emergency screen.
export const activeEmergency = incidents[0];

export const getIncidentById = (id) => incidents.find((i) => i.id === id);

export const formatTimestamp = (iso) => {
  if (!iso) return "Time unavailable";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "Time unavailable";
  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
